import * as React from "react"
import {ListItemButton, ListItemIcon, ListItemText, useTheme} from "@mui/material";
import {IconSeeker, TooltipSeeker} from "@ui-seeker/core"

import {useActiveLink, useTextCut} from "../../../../../../@hooks";
import NavBadge from "../../../../../../@componets/NavBadge";
import {MaximalLayoutNavVerticalIconStyles, MaximalLayoutNavVerticalItemStyles} from "./styles";


export default function MaximalLayoutNavVerticalItem({ path, title, icon, onClick, hasChildren=false, isOpen=false, isSubItem=false, active: activeProp, badge=null, sx={} }) {
    const theme = useTheme()
    const { active: linkActive } = useActiveLink(path, hasChildren)
    // Group rows have no `path`; their active state is supplied by the NavList
    // (true when any child route matches the current location).
    const active = activeProp ?? linkActive

    // A label that does not fit ends in "…" (noWrap) and shows whole on hover or focus, only when it is cut (CU-869fmjzrg)
    const [labelRef, labelCut] = useTextCut(title)

    const sxItem = MaximalLayoutNavVerticalItemStyles(active, isSubItem, theme)
    return <TooltipSeeker title={labelCut ? title : ''} placement="right">
        <ListItemButton sx={{ ...sxItem, ...sx.list }} onClick={onClick}>
            <ListItemIcon sx={{ ...MaximalLayoutNavVerticalIconStyles, ...sx.icon }}>
                 <IconSeeker  icon={icon} />
            </ListItemIcon>
            <ListItemText primary={title} primaryTypographyProps={{ ref: labelRef, noWrap: true, component: 'span', variant: active ? 'subtitle2' : 'body2' }} />
            { !!badge && <NavBadge label={badge} /> }

            { hasChildren && <IconSeeker icon={ isOpen ? "chevron-down" : "chevron-right" } /> }
        </ListItemButton>
    </TooltipSeeker>
}